import type { PostReactionTypes } from "shared/types";

import { emotionIcons } from "../modules/Member/View/Components/Post/Like/constants";

export const getReactionInfo = (type?: PostReactionTypes) => {
	return emotionIcons.find(x => x.value === type);
};
